"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeSumModalContents = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const formik_1 = require("formik");
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const Yup = __importStar(require("yup"));
const PreferencesContext_1 = require("../../context/PreferencesContext");
const Button_1 = __importDefault(require("../../elements/Button"));
const Tab_1 = __importDefault(require("../../elements/Tab/Tab"));
const Tabs_1 = __importDefault(require("../../elements/Tab/Tabs"));
const FormikInput_1 = __importDefault(require("../../elements/formik/FormikInput"));
const SelectMolecule_1 = __importDefault(require("./SelectMolecule"));
function getValidationSchema(option) {
    switch (option) {
        case 'auto': {
            return Yup.object({
                molecule: Yup.object().required(),
            });
        }
        case 'manual': {
            return Yup.object({
                sum: Yup.number().required(),
            });
        }
        default:
            return null;
    }
}
const ManualContainer = styled_1.default.div `
  padding: 30px 5px;

  .input {
    width: 80% !important;
    height: 36px;
    margin: 0 auto;
  }

  .input input {
    padding: 5px;
    text-align: center;
  }
`;
function ChangeSumModalContents(props) {
    const { currentSum, sumType, sumOptions, onSave, onClose } = props;
    const { current: { display: { panels }, }, } = (0, PreferencesContext_1.usePreferences)();
    const [setOption, setActiveOption] = (0, react_1.useState)('auto');
    const formRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (sumOptions?.sumAuto && panels?.structuresPanel?.display) {
            setActiveOption('auto');
            const { mf, moleculeId: id } = sumOptions;
            formRef.current.setValues({
                sum: null,
                molecule: id && mf ? { mf, id } : null,
            });
        }
        else {
            setActiveOption('manual');
            formRef.current.setValues({
                sum: sumOptions?.sum ?? '',
                molecule: null,
            });
        }
    }, [panels?.structuresPanel, sumOptions]);
    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            formRef.current.submitForm();
        }
    }
    function onTabChangeHandler(tab) {
        setActiveOption(tab.tabid);
    }
    function saveHandler(values) {
        switch (setOption) {
            case 'auto': {
                const { molecule: { mf, id: moleculeId }, } = values;
                onSave({ sumAuto: true, mf, moleculeId });
                break;
            }
            case 'manual': {
                const { sum } = values;
                onSave({ sum, sumAuto: false });
                break;
            }
            default:
                return;
        }
        onClose();
    }
    const isStructurePanelVisible = panels?.structuresPanel?.display || false;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.Modal.Header, { children: currentSum
                    ? `Set new ${sumType} sum (Current: ${currentSum.toFixed(2)})`
                    : `Set new ${sumType} Sum` }), (0, jsx_runtime_1.jsx)(ui_1.Modal.Body, { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { innerRef: formRef, onSubmit: saveHandler, initialValues: { sum: '', molecule: null }, validationSchema: getValidationSchema(setOption), children: (0, jsx_runtime_1.jsxs)(Tabs_1.default, { activeTab: setOption, onClick: onTabChangeHandler, children: [isStructurePanelVisible && ((0, jsx_runtime_1.jsx)(Tab_1.default, { title: "Auto", tabid: "auto", children: (0, jsx_runtime_1.jsx)(SelectMolecule_1.default, { name: "molecule" }) })), (0, jsx_runtime_1.jsx)(Tab_1.default, { title: "Manual", tabid: "manual", children: (0, jsx_runtime_1.jsx)(ManualContainer, { children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "sum", type: "number", placeholder: "Enter the new value", onKeyDown: handleKeyDown }) }) })] }) }) }), (0, jsx_runtime_1.jsx)(ui_1.Modal.Footer, { children: (0, jsx_runtime_1.jsx)(Button_1.default.Done, { onClick: () => formRef.current.submitForm(), style: { width: 80 }, children: "Set" }) })] }));
}
exports.ChangeSumModalContents = ChangeSumModalContents;
